import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, NumberBox, Popup, SelectBox, TextBox } from 'devextreme-react';
import { paymentService } from '../services/payment-service';
import DateBox, { DateBoxTypes, DisplayFormat } from 'devextreme-react/cjs/date-box';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';
import { TextBoxTypes } from 'devextreme-react/cjs/text-box';
import { NumberBoxTypes } from 'devextreme-react/cjs/number-box';
import OrderStatusCell from '../order/components/order-status-celll';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { toast } from 'react-toastify';
import { confirm } from 'devextreme/ui/dialog';

const PaymentCalender = () => {

    let dueStartDateValue = new Date();
    let dueEndDateValue = new Date();
    let invoiceDateValue :any; 
    let vendorValue: any;
    let invoiceNoValue: any;

    dueStartDateValue.setDate(dueStartDateValue.getDate() - 7);

    const dateLabel = { 'aria-label': 'Date' };
    const dataGridRef = useRef<DataGrid>(null);
    const dgVendorSummaryRef = useRef<DataGrid>(null);

    const [store, setStore] = useState<CustomStore>();
    const [storeVendorSummaries, setStoreVendorSummaries] = useState<CustomStore>();


    useEffect(() => {
        setStore(new CustomStore({
            key: ["invoiceId","unpaidAmount","waitingForApproceAmount"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    useEffect(() => {
        setStoreVendorSummaries(new CustomStore({
            key: ["id", "invoiceId"],
            load: onGetVendorSummaries,
            useDefaultSearch: true
        }));
    }, [])

    const onGetOrderData = useCallback(async () => {
        const x = await paymentService.getPaymentList(invoiceNoValue, vendorValue, invoiceDateValue, dueStartDateValue, dueEndDateValue);
        return x;
    }, []);

    const onGetVendorSummaries = useCallback(async () => {
        if (invoiceId) {
            const x = paymentService.getTransactions(invoiceId);
            return x;
        }
    }, [setStoreVendorSummaries]);

    const onQuery = useCallback(async () => {
        dataGridRef.current?.instance.refresh();
    }, []);

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const [vendorLookups] = useState(new CustomStore({
        load: paymentService.getVendorLookups
    }));


    const [paymentTypeLookup] = useState(new CustomStore({
        load: paymentService.paymentTypeLookup
    }));

    const onValueChangedStartDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        dueStartDateValue = e.value;
    }, []);

    const onValueChangedEndDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        dueEndDateValue = e.value;
    }, []);

    const onValueChangedInvoiceDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        invoiceDateValue = e.value;
    }, []);


    const onValueChangedVendor = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        vendorValue = e.value;
    }, []);

    const [paymentTypeValue, setPaymentValue] = useState("");
    const onValueChangedPaymentType = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setPaymentValue(e.value);
    }, []);

    const onValueChangedInvoiceNo = useCallback((e: TextBoxTypes.ValueChangedEvent) => {
        invoiceNoValue = e.value;
    }, []);


    const [referanceTypeValue, setReferanceTypeValue] = useState("");
    const onValueChangedReferanceNo = useCallback((e: TextBoxTypes.ValueChangedEvent) => {
        setReferanceTypeValue(e.value);
    }, []);

    const [amountValue, setAmountValue] = useState(0);
    const onValueChangedAmount = useCallback((e: NumberBoxTypes.ValueChangedEvent) => {
        setAmountValue(e.value)
    }, []);

    const [currencyValue, setCurrencyValue] = useState();
    const onValueChangedCurrency = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setCurrencyValue(e.value)
    }, []);

    const [popupVisibleOrders, setPopupVisibleOrders] = useState(false);
    const showInfoOrders = useCallback((e: any) => {
        setPopupVisibleOrders(true);
    }, [setPopupVisibleOrders]);

    const hideInfoOrders = useCallback(() => {
        setPopupVisibleOrders(false);
    }, [setPopupVisibleOrders]);



    const [popupVisibleTransactions, setPopupVisibleTransactions] = useState(false);
    const showInfoTransactions = useCallback((e: any) => {
        setPopupVisibleTransactions(true);
    }, [setPopupVisibleTransactions]);

    const hideInfoTransactions = useCallback(() => {
        setPopupVisibleTransactions(false);
    }, [setPopupVisibleTransactions]);

    const [invoiceId, setInvoiceId] = useState(0);
    const [unPaidAmount, setUnPaidAmount] = useState(0);
    const goToPayments = (id: number, unPaid: any) => {
        setInvoiceId(id);
        setUnPaidAmount(unPaid)
        showInfoOrders(true);
    }

    const goToTransactions = (id: number) => {
        paymentService.getTransactions(id).then(
            x => {
                setStoreVendorSummaries(x);
                showInfoTransactions(true);
            }
        );
    }

    const newPayment: any = {};
    const savePayment = () => {
        newPayment.invoiceId = invoiceId;
        newPayment.paymentType = paymentTypeValue;
        newPayment.paymentNumber = referanceTypeValue;
        newPayment.amount = amountValue;
        newPayment.currency = currencyValue;

        paymentService.savePayment(newPayment).then((response) => {
            toast.success(t("syncflow:msg_saved"));
            hideInfoOrders();
            dataGridRef.current?.instance.refresh();
        });
    }


    const [selectedRowKeys, setSelectedRowKeys] = useState<any | null>(null);
    const onSelectionChanged = (args: DataGridTypes.SelectionChangedEvent) => {
        setSelectedRowKeys(args.selectedRowKeys);
    };


    const deletePayment: any = [];
    const deleteFunc = () => {
        let invoiceValue = 0;
        if (selectedRowKeys.length > 0) {
            let result = confirm(t("syncflow:msg_approve_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    selectedRowKeys.forEach((e: any) => {
                        invoiceValue = e.invoiceId;
                        deletePayment.push({ invoiceId: e.invoiceId, sourceId: e.id });
                    });
                    paymentService.deletePayment(deletePayment).then((response) => {
                        // hideInfoTransactions(); 
                        goToTransactions(invoiceValue);
                        toast.success(t("syncflow:msg_saved"));
                        dataGridRef.current?.instance.refresh();
                    })
                }
            });
        }
    }

    const currencyTypes = [{
        code: "USD",
        name: 'USD',
    }
    ];


    return (
        <>

            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text="Search"
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
            </div>

            <div className="row">
                <label className="col-lg-1 col-form-label fw-bold fs-6">Vendors</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <SelectBox
                                name="vendorsLookups"
                                dataSource={vendorLookups}
                                onValueChanged={onValueChangedVendor}
                                valueExpr="code"
                                displayExpr="name"
                                searchEnabled={true}
                                showClearButton={true} />
                        </div>
                    </div>
                </div>

                <label className="col-lg-1 col-form-label fw-bold fs-6">Invoice No</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <TextBox onValueChanged={onValueChangedInvoiceNo} />
                        </div>
                    </div>
                </div>

                <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lb_invoice_start_date")}</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                name="invoiceDateValue"
                                defaultValue={invoiceDateValue}
                                inputAttr={dateLabel}
                                type="date"
                                showClearButton={true}
                                onValueChanged={onValueChangedInvoiceDate}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">

                <label className="col-lg-1 col-form-label fw-bold fs-6">Start Due Date</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                name="dueStartDateValue"
                                defaultValue={dueStartDateValue}
                                inputAttr={dateLabel}
                                type="date"
                                showClearButton={true}
                                onValueChanged={onValueChangedStartDate}
                            />
                        </div>
                    </div>
                </div>
                <label className="col-lg-1 col-form-label fw-bold fs-6">End Due Date</label>
                <div className="col-lg-2">
                    <div className="row">
                        <div className="fv-row">
                            <DateBox
                                name="dueEndDateValue"
                                defaultValue={dueEndDateValue}
                                inputAttr={dateLabel}
                                type="date"
                                showClearButton={true}
                                onValueChanged={onValueChangedEndDate}
                            />
                        </div>
                    </div>
                </div>

            </div>


            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: false,
                        updateMessageText: RemoveMessage('Resource'),
                    }}

                    columns={[
                        {
                            dataField: 'vendorName',
                            caption: "Vendor",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'invoiceNo',
                            caption: "Invoice No",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'invoiceDate',
                            caption: "Invoice Date",
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'orders',
                            caption: "Orders",
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'orderDate',
                            caption: "Order Date",
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'deliveryDate',
                            caption: "Delivery Date",
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'dueDate',
                            caption: "Due Date",
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'invStatus',
                            caption: "Inv Status",
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                let account = data.row.data;
                                return (
                                    <OrderStatusCell statusCode={account?.invStatus} isAllApproved={0 == account?.unpaidAmount} label={t('syncflow:lb_order_supplier_status_' + account?.invStatus)} ></OrderStatusCell>
                                )
                            },
                        },
                        {
                            dataField: 'totalAmount',
                            caption: "Total Amount",
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        {
                            dataField: 'unpaidAmount',
                            caption: "Unpaid Amount",
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },

                        {
                            dataField: 'approvedAmount',
                            caption: "Approved Amount",
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },

                        {
                            dataField: 'waitingForApproceAmount',
                            caption: "Waiting Amount",
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },

                        {
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text="New Payment"
                                        type="default"
                                        stylingMode="contained"
                                        onClick={() => goToPayments(data.key.invoiceId, (parseFloat(data.key.unpaidAmount)-parseFloat(data.key.waitingForApproceAmount)).toFixed(2))}
                                    />
                                );
                            },
                        },
                        {
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text={t("syncflow:lb_payments")}
                                        type={data.row.data.waitingForApproceAmount > 0 ? "danger" : "default"}
                                        stylingMode="contained"
                                        onClick={() => goToTransactions(data.key.invoiceId)}
                                    />
                                );
                            },
                        }
                    ]}
                />
            </React.Fragment>

            <Popup
                visible={popupVisibleOrders}
                onHiding={hideInfoOrders}
                title="New Payment"
                showTitle={true}
                width={400}
                height={320}
                position={{ of: window, at: 'center', my: 'center' }}
            >

                <div className="row">
                    <label className="col-lg-5 col-form-label fw-bold fs-6">Payment Method</label>
                    <div className="col-lg-7">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="paymentTypeLookup"
                                    dataSource={paymentTypeLookup}
                                    onValueChanged={onValueChangedPaymentType}
                                    valueExpr="code"
                                    displayExpr="name"
                                    searchEnabled={true}
                                    showClearButton={true} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <label className="col-lg-5 col-form-label fw-bold fs-6">Referance No</label>
                    <div className="col-lg-7">
                        <div className="row">
                            <div className="fv-row">
                                <TextBox onValueChanged={onValueChangedReferanceNo} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <label className="col-lg-5 col-form-label fw-bold fs-6">Amount</label>
                    <div className="col-lg-7">
                        <div className="row">
                            <div className="fv-row">
                                <NumberBox
                                    max={unPaidAmount}
                                    min={0}
                                    onValueChanged={onValueChangedAmount}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <label className="col-lg-5 col-form-label fw-bold fs-6">Currency</label>
                    <div className="col-lg-7">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="paymentTypeLookup"
                                    items={currencyTypes}
                                    onValueChanged={onValueChangedCurrency}
                                    valueExpr="code"
                                    displayExpr="name"
                                    searchEnabled={true}
                                    showClearButton={true} />
                            </div>
                        </div>
                    </div>
                </div>
                <br></br>
                <div className='row mb-4 justify-content-end'>
                    <div className='col-auto'>
                        <Button
                            text={t("syncflow:btn_save")}
                            type="default"
                            stylingMode="contained"
                            icon="check"
                            onClick={savePayment}
                        />
                    </div>
                </div>



            </Popup>



            <Popup
                visible={popupVisibleTransactions}
                onHiding={hideInfoTransactions}
                title={t("syncflow:lb_payments")}
                showTitle={true}
                width={800}
                height={750}
                position={{ of: window, at: 'center', my: 'center' }}
            >
                <div className='row mb-4 justify-content-end'>
                    <div className='col-auto'>
                        <Button
                            text="Delete"
                            type="default"
                            stylingMode="contained"
                            icon="check"
                            onClick={deleteFunc}
                        />
                    </div>
                </div>

                <DataGridWrapper
                    props={{ ref: dgVendorSummaryRef }}
                    datasource={storeVendorSummaries}
                    showColumnLines={true}
                    onSelectionChanged={onSelectionChanged}
                    remoteOperations={false}
                    columnChooser={false}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    selectionConfig={{ mode: 'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }}
                    editingConfig={{
                        mode: "batch",
                        allowDeleting: false,
                        allowUpdating: true,

                    }}
                    columns={[
                        {
                            dataField: 'transactionDate',
                            caption: 'Payment Date',
                            allowFiltering: false,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'paymentNumber',
                            caption: 'Payment Number',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                         {
                            dataField: 'paymentType',
                            caption: 'Payment Type',
                            allowFiltering: false,
                            allowEditing: false,
                            cellRender: payment_type_render,
                        },
                        {
                            dataField: 'status',
                            caption: 'Status',
                            allowFiltering: false,
                            allowEditing: false,
                            cellRender: status_cell_render,
                        },
                        {
                            dataField: 'amount',
                            caption: 'Paid Amount',
                            allowFiltering: false,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                    ]}
                />

            </Popup>

        </>


    )
}
const status_cell_render = (data: any) => (t('syncflow:lb_order_supplier_status_' + data.row.data.status));
const payment_type_render = (data: any) => (t('syncflow:lb_payment_type_' + data.row.data.paymentType));
export default PaymentCalender